import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatTableDataSource, MatSort, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-country',
  templateUrl: './country.component.html',
  styleUrls: ['./country.component.css']
})
export class CountryComponent implements OnInit {

  model = { 'table_name': 'country', 'country_id': '0', 'country_name': '', 'country_name_en': '', 'comment': '' };

  Success_Msg; Error_Msg; Country_Name_Msg;

  constructor(private utils: Utils, private applicationConstants: ApplicationConstants,
    private queryList: QueryList, private dialogRef: MatDialogRef<CountryComponent>,
    @Inject(MAT_DIALOG_DATA) public dialog_data: any, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);


    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

    translate.get('Country_Name_Msg').subscribe((res: string) => {
      this.Country_Name_Msg = res;
    });

  }

  ngOnInit() {

    if (this.dialog_data != null)
      this.model = this.dialog_data;
  }

  add() {
    if (this.model['country_name'] != '') {
      let values = [];
      values.push(this.model);

      let obj;
      if (this.model['country_id'] == '0')
        obj = { cmd: 'add', values: values };
      else {
        let where = [{ 'country_id': this.model['country_id'] }];
        obj = { cmd: 'update', values: values, where: where };
      }
      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          if (data.status['type'] == 'success') {
            alert(this.Success_Msg);
            // this.dialog_data = {
            //   'status': data.status['type']
            // };
            this.dialog_data = { 'op_type': 'success' };
            this.dialogRef.close(this.dialog_data);
          }
          else {
            alert(this.Error_Msg);
          }
        });
    }
    else if (this.model['country_name'] == '') {
      alert(this.Country_Name_Msg);
    }
  }

  cancel() {
    this.dialog_data = { 'op_type': 'cancel' };
    this.dialogRef.close(this.dialog_data);
  }

}
